import React, { Fragment } from "react";
import {
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown
} from "reactstrap";
import { humanFileSize } from "../../../utils";
import _ from "lodash";

export default function (props) {
    const g = props.group;
    const versions = _.reverse(_.sortBy(g.files, "timestamp"));

    if (versions.length === 0) {
        return <p className="bold pt-3">{g.title}</p>;
    }

    const latest = versions[0];

    const trackDownload = (url) => {
        if (window._paq) {
            window._paq.push(["trackLink", url, "download"]);
        }
    };

    const filenameFromUrl = (url) => url.substring(url.lastIndexOf("/") + 1);

    const downloadLink = (url, label, key = null) => (
        <DropdownItem
            key={key}
            tag="a"
            href={url}
            download
            onClick={() => trackDownload(url)}
        >
            {label}
        </DropdownItem>
    );

    return (
        <div className="dataset-card">
            <p className="bold pt-2">
                {g.title.replace(/CRISPR KO/g, "CRISPR Dependencies")}
            </p>

            <p className="dataset-title">
</p>

<p className="dataset-download">
  {g.link_lead}{" "}
  <strong>
    <a
      href={latest.url}
      download
      onClick={() => trackDownload(latest.url)}
    >
      {g.link_text}
    </a>
  </strong>{" "}
  {latest.size ? `(${humanFileSize(latest.size)})` : ""}
  <br />
  <em>
                    <small>{g.description}</small>
                </em>

</p>

            {!g.title.includes("CRISPR KO Target Priority Scores") &&
                !g.title.includes("Augmented Multiomics") &&
                !g.title.includes("CRISPR KO Fitness Scores (Archive)") && (
                    <div className="small">
                        <UncontrolledDropdown>
                            Archive:
                            <DropdownToggle caret color="link">
                                View all versions
                            </DropdownToggle>

                            <DropdownMenu>
                                <DropdownItem header>Current</DropdownItem>

                                {downloadLink(
                                    latest.url,
                                    filenameFromUrl(latest.url)
                                )}

                                {versions.length > 1 && (
                                    <Fragment>
                                        <DropdownItem header>
                                            Previous
                                        </DropdownItem>

                                        {versions.slice(1).map((v) =>
                                            downloadLink(
                                                v.url,
                                                filenameFromUrl(v.url),
                                                v.id
                                            )
                                        )}
                                    </Fragment>
                                )}
                            </DropdownMenu>
                        </UncontrolledDropdown>

                        {g.latest_link && (
                            <p>
                                Stable{" "}
                                <a
                                    href={g.latest_link}
                                    download
                                    onClick={() =>
                                        trackDownload(g.latest_link)
                                    }
                                >
                                    link
                                </a>{" "}
                                that always points to the latest version.
                            </p>
                        )}
                    </div>
                )}
        </div>
    );
}